import React from 'react';
import { useLocation } from 'react-router-dom';
import LanguageToggle from './LanguageToggle';

export default function GlobalLanguageControl() {
  const { pathname } = useLocation();
  if (/^\/(admin|chat|password-reset|properties\/list|add-contact)/.test(pathname)) return null;
  return <div className="global-language-control"><LanguageToggle /></div>;
}
